var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"tables"},[_c('div',{staticClass:"row"},[_c('Breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('div',{staticClass:"col-lg-10 offset-lg-1 grid-margin stretch-card"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('createForm')],1)])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }